import type { ParticipantBehaviour } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { inflection, P } from '@piccolohealth/util';
import React from 'react';

interface Props {
  behaviour: ParticipantBehaviour;
}

export const SeriesListItem = (props: React.PropsWithChildren<Props>) => {
  const { behaviour, children } = props;

  const methodsWithData = P.groupBy(behaviour.recordings, (recording) => recording.method.id);
  const methodsWithDataCount = Object.keys(methodsWithData).length;

  return (
    <ChakraV3.Stack
      key={behaviour.id}
      w='full'
      gap={2}
      borderLeftWidth='4px'
      borderLeftColor='purple.400'
      pl={4}
      py={1}
    >
      <ChakraV3.Stack gap={0}>
        <ChakraV3.Text fontSize='md' fontWeight='bold'>
          {behaviour.name}
        </ChakraV3.Text>
        <ChakraV3.Text fontSize='sm' color='secondary'>
          {methodsWithDataCount} {inflection.inflect('method', methodsWithDataCount)} with data
        </ChakraV3.Text>
      </ChakraV3.Stack>

      <ChakraV3.Stack>{children}</ChakraV3.Stack>
    </ChakraV3.Stack>
  );
};
